import { isValidNum, round } from '@oliasoft-open-source/units';

export const getActivityVariance = (activity: any): number | '' => {
  if (isValidNum(activity?.actual) && isValidNum(activity?.afe)) {
    return round(activity.actual - activity.afe, 2);
  }

  return '';
};

export const getOperationVariance = (operation: any): number =>
  round(
    (operation?.activities ?? []).reduce((sum: number, activity: any) => {
      const variance = getActivityVariance(activity);
      return sum + (typeof variance === 'number' ? variance : 0);
    }, 0),
    2,
  );

export const getTotalVariance = (operations: any[]): number =>
  round(
    operations.reduce((sum: number, operation: any) => sum + getOperationVariance(operation), 0),
    2,
  );
